import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams, Link } from "react-router-dom";
import { LuPencil } from "react-icons/lu";

import useAllClasses from "hooks/useAllClasses";
import { CLASS_PATH } from "router/pathName";

const ClassName = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const { classes } = useAllClasses();

  const [className, setClassName] = useState("");
  useEffect(() => {
    if (isNaN(parseInt(id || ""))) return;
    const currentClass = classes.find((c) => c.id === parseInt(id || ""));
    if (!currentClass) return;
    setClassName(`${currentClass.year} - ${currentClass.name}`);
  }, [id, classes]);

  return (
    <div className="flex flex-wrap items-center gap-2 lg:gap-3">
      <h3 className="font-medium text-xl lg:text-2xl">{className}</h3>
      <div className="flex items-center">
        <Link
          to={`${CLASS_PATH}/${id}`}
          className="group inline-flex items-center gap-1 rounded-md text-sm font-bold text-[#5B5B5B] transition-colors duration-200 ease-out hover:text-[#00A09B] lg:text-base"
        >
          <LuPencil size={16} />
          <span className="group-hover:underline">
            {t("_student._change_class_name")}
          </span>
        </Link>
      </div>
    </div>
  );
};

export default ClassName;
